import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'ckeditor5/ckeditor5.css';
import App from './App';
import { ThemeModeProvider } from './theme/ThemeModeContext';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
